import React, {useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import {Grid} from '@mui/material';
import '../../globals/services-styles.css';
import {ContPldPage, BtnOnbard, ContButton, IndentityPhoneImg } from './PldPage.styles';
import { IdentityCont, ContTextIdentity, TextIdentitySummary, ContCardIdentity, ContOnb, ContHowWork, ContTextDescHowWork, TitleHowWork, TextDescHowWork } from '../globalpages.styles';
import PldService from '../../assets/images/Servicios/img-pld-beneficios.webp';
import ButtonSpecial from '../../components/ButtonSpecial';
import ActionDemo from '../../components/ActionDemo/index';
import { CoreBancarioFAQ } from '../../components/CoreBancarioFAQ';
import PldMethod from '../../assets/images/Servicios/pld-method.webp';
import ServicesBeneficios from '../../components/ServicesBeneficios/index';

const PldItems = [
  {
    title: 'Validación de identidad.',
  },
  {
    title: 'Búsqueda en listas negras OFAC, FBI, SAT, PEPs nacionales e internacionales.',
  },
  {
    title: 'Recibe alertas de fraude.',
  },
  {
    title: 'Revisión de transacciones inusuales, relevantes o preocupantes.',
  },
  {
    title: 'Reportes automatizados.',
  }
];

const pldFaqData = [
  {
    id: 1,
    question: '¿Qué es el módulo PLD?',
    answer: 'Este módulo permite automatizar la identificación de clientes, revisar su historial financiero y generar alertas ante actividades sospechosas. Esto facilita el cumplimiento de normativas como las impuestas por la CNBV y la Ley Federal para la Prevención e Identificación de Operaciones con Recursos de Procedencia Ilícita en México.',
    relatedLinks: [
      {
        label: 'Prevención de lavado de dinero con software PLD',
        href: 'https://blog.dynamicore.io/',
      },
      {
        label: 'Revolucionando la gestión de Riesgos Crediticios',
        href: 'https://blog.dynamicore.io/',
      },
    ],
  },
  {
    id: 2,
    question: '¿Qué beneficios tiene el módulo PLD?',
    answerIntro: '',
    answerList: [
      'Generar reportes regulatorio solicitados por la CNBV de manera automática.',
      'Parametrizar tu matriz de riesgo de acuerdo al manual de riesgo de tu entidad.',
      'Generar alertas inusuales, relevantes y preocupantes para prevenir riesgo de fraude.',
    ],
    answerClosing: '',
    relatedLinks: [
      {
        label: '5 error errores comunes en la prevención de lavado de dinero (y cómo evitarlos)',
        href: 'https://blog.dynamicore.io/',
      },
    ],
  },
  {
    id: 3,
    question: '¿Puedo consultar las distintas listas negras y PEPs?',
    answer: 'Si, se pueden consultar, así puedes cargar de manera manual tus listas negras y listas de personas bloqueadas.',
    relatedLinks: [
      {
        label: 'Prevención de lavado de dinero con software PLD',
        href: 'https://blog.dynamicore.io/',
      },
    ],
  },
  {
    id: 4,
    question: '¿Qué debe cumplir un sistema PLD bajo la reforma de Ley Federal para la Prevención e Identificación de Operaciones con recursos de procedencia ilícita (LFPIORPI)?',
    answerIntro: 'Los principales cambios impulsados por la reforma LFPIORPI es que las organizaciones deberán adoptar controles más rigurosos, apoyarse e tecnologías avanzadas y aplicar un enfoque proactivo para la gestión de riesgos en materia de PLD.\n\nLos cambios clave que debes conocer son:',
    answerListType: 'ordered',
    answerList: [
      'Enfoque Basado en Riesgos (EBR): la nueva regla de oro',
      'Sistemas automáticos y uso de IA en el monitoreo de operaciones',
      'Beneficiario finales y transparencia corporativa',
      'Auditoría y supervisión obligatoria',
    ],
    answerClosing: '',
    relatedLinks: [
      {
        label: 'Ponte al día: Así impactará la reforma LFPIORPI al cumplimiento PLD',
        href: 'https://blog.dynamicore.io/',
      },
    ],
  },
];

export const PldPage = () => {
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
 return(
  <ContPldPage id={'ContPldPage'}>
    <ContCardIdentity id={'ContCardIdentity'}>
      <IdentityCont>
        <Grid container spacing={2} className={'ContCardIdentity GridBlueCard'}>
          <Grid item xs={12} sm={12} md={6} order={{ xs: 1, sm: 1, md: 1 }} style={{paddingLeft: '5%'}}>
            <ContOnb>
              <BtnOnbard adjustSize={true}>
                {t('Prevención de Lavado de Dinero (PLD)')}
              </BtnOnbard>
            </ContOnb>
            <ContTextIdentity>
              {t('Cumple con normativas y prevén riesgo de fraude.')}
            </ContTextIdentity>
            <TextIdentitySummary>
              {t('Conoce el perfil de tus clientes en las principales listas financieras a nivel mundial y cumple con todas las normativas con nuestro módulo de Prevención de Lavado de Dinero (PLD).')}
            </TextIdentitySummary>
            <ContButton>
              <ButtonSpecial text={'Prueba la versión Demo'} type={'/'} linkTo={'/contacto'} target={'_self'} theme={'secondary'}/>
            </ContButton>
          </Grid>
          <Grid item xs={12} sm={12} md={6} 
            order={{ xs: 2, sm: 2, md: 2 }}
            className={'GridStylesCardImage'}
          >
            <IndentityPhoneImg src={PldMethod} alt={'Prevención de lavado de dinero'} visible={true} width={430} />
          </Grid>
        </Grid>
      </IdentityCont>
    </ContCardIdentity>

    <ContHowWork id={'ContHowWork'}>
      <TitleHowWork>
        {t('¿Cómo funciona?')}
      </TitleHowWork>
      <ContTextDescHowWork>
        <TextDescHowWork>
          {t('Identifica y evalúa a tus clientes revisando las principales listas negras, PEPs nacionales e internacionales (Persona políticamente expuesta) y genera alertas para prevenir riesgo de fraude.')}
        </TextDescHowWork>
      </ContTextDescHowWork>
      
      <ContButton>
        <ButtonSpecial text={'Prueba la versión Demo'} type={'/'} linkTo={'/contacto'} target={'_self'} theme={'primary'}/>
      </ContButton>
    </ContHowWork>

    <ServicesBeneficios items={PldItems} image={PldService} alt={'PEPs nacionales e internacionales'} />

    <CoreBancarioFAQ faqData={pldFaqData} />

    <ActionDemo />

  </ContPldPage>
 )
};
